import { AppointmentPage } from "./appointment";

export const Appointment = AppointmentPage;
